var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetrol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 16.875V4.375C4.875 4.04348 5.0067 3.72554 5.24112 3.49112C5.47554 3.2567 5.79348 3.125 6.125 3.125H12.375C12.7065 3.125 13.0245 3.2567 13.2589 3.49112C13.4933 3.72554 13.625 4.04348 13.625 4.375V16.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.875H15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 8.75H15.5C15.8315 8.75 16.1495 8.8817 16.3839 9.11612C16.6183 9.35054 16.75 9.66848 16.75 10V13.125C16.75 13.4565 16.8817 13.7745 17.1161 14.0089C17.3505 14.2433 17.6685 14.375 18 14.375C18.3315 14.375 18.6495 14.2433 18.8839 14.0089C19.1183 13.7745 19.25 13.4565 19.25 13.125V6.76562C19.2486 6.43449 19.1166 6.11728 18.8828 5.88281L17.375 4.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 8.75H7.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetrol);
export default __webpack_public_path__ + "static/media/petrol.73fb4d1d6a54ab3ee45780b70638f62c.svg";
export { ForwardRef as ReactComponent };